import { render, staticRenderFns } from "./page9.vue?vue&type=template&id=62d02b5e&scoped=true&"
import script from "./page9.vue?vue&type=script&lang=js&"
export * from "./page9.vue?vue&type=script&lang=js&"
import style0 from "./page9.vue?vue&type=style&index=0&id=62d02b5e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d02b5e",
  null
  
)

export default component.exports